<template>
    <form class="posfinder-screen__form" @submit.prevent="startSearch" :class="{'is-open': openForm}">
        <div class="posfinder-screen__form-wrapper">
            <div class="posfinder-screen__group">
                <div class="posfinder__form posfinder__form--finder">
                    <input class="font_input" type="text" v-model="form.query" placeholder="Ort oder PLZ eingeben">
                    <button v-if="form.query.length > 0" type="submit" @click.prevent="startSearch(false)">
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13L7 7L0.999999 1" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                        </svg>
                    </button>
                    <button v-else type="submit" @click.prevent="startGeo">
                        <div>
                            <svg width="14" height="26" viewBox="0 0 14 26" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.5 23.5C13.5 23.6409 13.4214 23.8428 13.1273 24.0911C12.8356 24.3375 12.3837 24.5819 11.7816 24.7969C10.5817 25.2254 8.8912 25.5 7 25.5C5.1088 25.5 3.4183 25.2254 2.21842 24.7969C1.6163 24.5819 1.16445 24.3375 0.872671 24.0911C0.578575 23.8428 0.5 23.6409 0.5 23.5C0.5 23.3591 0.578575 23.1572 0.872671 22.9089C1.16445 22.6625 1.6163 22.4181 2.21842 22.2031C3.4183 21.7746 5.1088 21.5 7 21.5C8.8912 21.5 10.5817 21.7746 11.7816 22.2031C12.3837 22.4181 12.8356 22.6625 13.1273 22.9089C13.4214 23.1572 13.5 23.3591 13.5 23.5Z"
                                    stroke="#EFF3F5"/>
                                <rect x="5.75" y="8.75" width="2.5" height="15.5" rx="1.25" fill="white"
                                      stroke="#00417D"
                                      stroke-width="0.5"/>
                                <circle cx="7" cy="7" r="6.5" fill="white" stroke="#00417D"/>
                            </svg>
                            <span>Standort</span>
                        </div>
                    </button>
                </div>
                <div class="posfinder-screen__range">
                    <input type="range" v-model="form.filter" :min="filter.min" :max="filter.max" :step="filter.steps"
                           @change="startSearch(false)">
                    <span class="font_mini">
                    {{ form.filter }}km
                    Umkreis
                </span>
                </div>
            </div>
            
            <Spinner v-if="!ready && loading" :loading="true" :inline="true"/>
            <template v-else>
                <div
                    class="posfinder-screen__group posfinder-screen__group--grey"
                    :class="{'is-hidden': !filterOpen}"
                >
                    <div class="posfinder-screen__field">
                        <label class="posfinder-screen__label">
                            Marke
                        </label>
                        <ButtonSelect
                            v-model="form.brands"
                            :options="brandList"
                            :title="b => b.name"
                            @change="startSearch(true)"
                        />
                    </div>
                    
                    <div class="posfinder-screen__field">
                        <label class="posfinder-screen__label">
                            Produkte
                        </label>
                        <MultiSelect
                            :disabled="form.brands.length === 0"
                            :forceClose="!openForm"
                            v-model="form.products"
                            :options="selectedBrandList"
                            :title="p => p.name"
                            @change="startSearch(true)"
                        />
                    </div>
                </div>
            </template>
        </div>
        <button
            class="posfinder-screen__form-reveal"
            :class="{'is-fill': initial && filterOpen || !initial}"
            @click.prevent="handleRevealButton"
        >
            <span v-if="initial && !filterOpen">
                Getränk auswählen
            </span>
            <template v-else>
                Auswahl
                <span v-if="openForm && filterOpen">schließen</span>
                <span v-else>anzeigen</span>
            </template>
        </button>
    </form>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import MultiSelect from "./partials/MultiSelect";
    import ButtonSelect from "./partials/ButtonSelect";
    import Spinner from "./partials/Spinner";
    
    export default {
        name: "Form",
        components: {Spinner, ButtonSelect, MultiSelect},
        props: {
            defaultQuery: String,
            initial: Boolean,
            initGeo: Boolean,
            defaultProduct: Number,
            loading: Boolean
        },
        watch: {
            initial: 'handleInitialChange',
            brandList: 'applyBrandSelect'
        },
        data() {
            return {
                filter: {
                    min: 5,
                    max: 50,
                    steps: 5
                },
                form: {
                    query: '',
                    filter: 5,
                    coords: {
                        lat: null,
                        lon: null
                    },
                    brands: [],
                    products: []
                },
                ready: false
            }
        },
        async mounted() {
            if (this.defaultQuery) {
                this.form.query = this.defaultQuery;
            }
        },
        computed: {
            ...mapState({
                openForm: 'formOpen',
                filterOpen: 'filterOpen',
                brandList: 'brands'
            }),
            posFinderQuery() {
                const query = {
                    distance: parseInt(this.form.filter),
                    products: this.form.products,
                    brands: this.form.brands
                };
                if (this.form.query.length === 0) {
                    query.coords = this.form.coords;
                } else {
                    query.query = this.form.query;
                }
                return query;
            },
            selectedBrandList() {
                return this.form.brands.sort((a, b) => {
                    return a - b;
                }).map(b => this.getBrandById(b));
            }
        },
        methods: {
            getBrandById(id) {
                for (let i = 0; i < this.brandList.length; i++) {
                    if (this.brandList[i].id === id) {
                        return this.brandList[i];
                    }
                }
                return null;
            },
            applyBrandSelect() {
                if (this.ready) {
                    return;
                }
                this.brandList.forEach(b => {
                    b.products.forEach(p => {
                        if (p.id === this.defaultProduct) {
                            this.form.brands = [b.id];
                            this.form.products = [p.id];
                        }
                    });
                })
                if (this.initGeo) {
                    this.startGeo();
                } else {
                    this.startSearch();
                }
                this.ready = true;
            },
            handleInitialChange() {
                this.$store.commit('setFilterOpenState', !this.initial);
            },
            handleRevealButton() {
                if (this.initial) {
                    this.$store.commit('setFilterOpenState', !this.filterOpen);
                    return;
                }
                this.$store.commit('setFormOpenState', !this.openForm);
                this.$store.commit('setResultOpenState', false);
            },
            async startGeo() {
                this.$emit('loadStart');
                try {
                    const coords = await this.getCoords();
                    this.form.coords.lat = coords.coords.latitude;
                    this.form.coords.lon = coords.coords.longitude;
                } catch (e) {
                    console.error(e);
                }
                this.$emit('loadEnd');
                this.startSearch();
            },
            startSearch(silent) {
                if (this.form.query.length === 0) {
                    if (this.form.coords.lat === null && this.form.coords.lon === null) {
                        return;
                    }
                }
                this.$emit('startSearch', {
                    query: this.posFinderQuery,
                    silent
                });
            },
            async getCoords() {
                return new Promise((resolve, reject) => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(resolve, e => reject(e.message));
                        setTimeout(() => {
                            reject("timeout");
                        }, 10000);
                        return;
                    }
                    reject("not supported");
                });
            }
        }
    }
</script>
